export enum SortTypes {
    dateAsc = 'DATE_FROM_ASC',
    dateDesc = 'DATE_FROM_DESC',
    nameAsc = 'NAME_ASC',
    nameDesc = 'NAME_DESC',
}
